import { Communication, CommunicationApiResponseSuccess, MessageRequestWithMeta } from '../../interface';
import { Observable } from 'rxjs';
import { MessageRequest } from '@skyeng/libs/skypro/messages';

export abstract class CommunicationFormService {
  abstract isLoading$: Observable<boolean>;
  abstract pollCommunication(
    communicationId: number,
    lastThreadId: number | null,
    sortByOwnThreads?: boolean,
    hasLazyLoadFeature?: boolean,
  ): Observable<Communication>;
  abstract getCommunication(
    communicationId: number,
    lastThreadId: number | null,
    hasLazyLoadFeature?: boolean,
  ): Observable<Communication>;
  abstract createThread(message: MessageRequest): Observable<CommunicationApiResponseSuccess>;
  abstract editThread(message: MessageRequest, threadId: number): Observable<CommunicationApiResponseSuccess>;
  abstract deleteThread(threadId: number): Observable<CommunicationApiResponseSuccess>;
  abstract pinThread(threadId: number): Observable<CommunicationApiResponseSuccess>;
  abstract unpinThread(threadId: number): Observable<CommunicationApiResponseSuccess>;
  abstract hideThread(threadId: number): Observable<CommunicationApiResponseSuccess>;
  abstract showThread(threadId: number): Observable<CommunicationApiResponseSuccess>;
  abstract replyInThread(
    message: MessageRequestWithMeta,
    threadId: number,
  ): Observable<CommunicationApiResponseSuccess>;
  abstract editMessageInThread(message: MessageRequest, messageId: number): Observable<CommunicationApiResponseSuccess>;
  abstract deleteMessageInThread(messageId: number): Observable<CommunicationApiResponseSuccess>;
  abstract forcePoll(): void;
}
